import { shallowEqual, useSelector } from 'react-redux';
import { getTotalWinners } from '../../selectors';
import { IStore } from 'store/interface';
import { ITopPlayer } from '../../interfaces/reducer.statistics.interfaces';

export const useTotalWinners = () => ({
  users: useSelector<IStore, ITopPlayer[]>(getTotalWinners, shallowEqual),
});
